import _defineProperty from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _created$mounted$data;

import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import topHeader from "../../components/home/header";
import Linktothe from "../../components/LinkTothe/linkTothe";
import Footer from "../../components/Footer/Footer";
import Logins from "../webSite/Login/login";
import Registered from "../webSite/Login/registered/registered";
import ForgotPassword from "../webSite/Login/forgotPassword/forgotPassword";
import FloatBox from "../webSite/floatBox/floatBox";
export default (_created$mounted$data = {
  created: function created() {},
  mounted: function mounted() {//通过IP获取位置信息
    // this.getLocation();
  },
  data: function data() {
    return {
      //点击搜索
      searchFlag: false,
      //登录弹出框
      loginflag: false,
      //登录或是注册
      flag: true,
      //修改密码
      forgotPasswordflag: false,
      province: '',
      //省
      city: '',
      //市
      district: '' //区

    };
  },
  components: {
    topHeader: topHeader,
    Linktothe: Linktothe,
    Footer: Footer,
    Logins: Logins,
    Registered: Registered,
    ForgotPassword: ForgotPassword,
    FloatBox: FloatBox
  }
}, _defineProperty(_created$mounted$data, "mounted", function mounted() {// this.requestBanner()
}), _defineProperty(_created$mounted$data, "methods", {
  requestBanner: function requestBanner() {
    var _this = this;

    var data = {
      brcId: '',
      location: ''
    };
    this.requestAPI.bannerQuery(data).then(function (res) {
      _this.joinList = res.data.content;
      _this.total = res.data.totalCount;
    });
  },
  getLocation: function getLocation() {
    var self = this;
    AMap.plugin('AMap.Geolocation', function () {
      var geolocation = new AMap.Geolocation({
        // 是否使用高精度定位，默认：true
        enableHighAccuracy: true,
        // 设置定位超时时间，默认：无穷大
        timeout: 10000
      });
      geolocation.getCurrentPosition();
      AMap.event.addListener(geolocation, 'complete', onComplete);
      AMap.event.addListener(geolocation, 'error', onError);

      function onComplete(data) {
        // data是具体的定位信息
        // console.log('定位成功信息：', data);
        this.province = data.addressComponent.province;
        this.city = data.addressComponent.city;
        this.district = data.addressComponent.district;
      }

      function onError(data) {
        // 定位出错
        // console.log('定位失败错误：', data);
        // 调用ip定位
        self.getLngLatLocation();
      }
    });
  },
  getLngLatLocation: function getLngLatLocation() {
    AMap.plugin('AMap.CitySearch', function () {
      var citySearch = new AMap.CitySearch();
      citySearch.getLocalCity(function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          // 查询成功，result即为当前所在城市信息
          // console.log('通过ip获取当前城市：', result)
          //逆向地理编码
          AMap.plugin('AMap.Geocoder', function () {
            var geocoder = new AMap.Geocoder({
              // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
              city: result.adcode
            });
            var lnglat = result.rectangle.split(';')[0].split(',');
            geocoder.getAddress(lnglat, function (status, data) {
              if (status === 'complete' && data.info === 'OK') {
                // result为对应的地理位置详细信息
                return data;
              }
            });
          });
        }
      });
    });
  },
  forgo: function forgo() {
    this.forgotPasswordflag = false;
  },
  handSearch: function handSearch(value) {
    this.searchFlag = value;
  },
  forgotFlag: function forgotFlag() {
    this.forgotPasswordflag = false;
  },
  login: function login() {
    this.flag = true;
    this.forgotPasswordflag = false;
  },
  //关闭弹出框
  del: function del() {
    this.loginflag = false;

    var mo = function mo(e) {
      e.preventDefault();
    };

    document.body.style.overflow = ""; //出现滚动条

    document.removeEventListener("touchmove", mo, false);
  },
  //登录跳转注册
  zcs: function zcs() {
    this.flag = false;
  },
  //注册按钮
  registered: function registered() {
    this.flag = false; //判断是登录还是注册

    this.forgotPasswordflag = false;
  },
  //忘记密码按钮
  forgotPassword: function forgotPassword() {
    this.forgotPasswordflag = !this.forgotPasswordflag;
  },
  //注册转登录
  RegisteredFlag: function RegisteredFlag() {
    this.flag = !this.flag;
  },
  // 返回顶部
  getTop: function getTop() {
    this.$refs.webSiteRef.scrollTop = 0;
  }
}), _created$mounted$data);